import type { ISecodaEditor, MenuItem } from '../..';
// @ts-expect-error TS(7016): Could not find a declaration file for module 'fuzzy-search'.
import FuzzySearch from 'fuzzy-search';
import gemojies from 'gemoji';
import { useCallback, useMemo } from 'react';
import { Toolbar } from '../../types';
import { CommandMenu } from './CommandMenu';
import { CommandMenuItem } from './CommandMenuItem';

interface EmojiMenuItem extends MenuItem {
	name: string;
	title: string;
	emoji: string;
	description: string;
	attrs: { markup: string; 'data-name': string };
}

const searcher = new FuzzySearch<{
	names: string[];
	description: string;
	emoji: string;
}>(gemojies, ['names'], {
	caseSensitive: true,
	sort: true,
});

export function EmojiMenu({ editor }: { editor: ISecodaEditor }) {
	const items = useMemo(() => {
		const n = (editor.blockMenuSearch ?? '').toLowerCase();
		// @ts-expect-error TS(7006): Parameter 'item' implicitly has an 'any' type.
		const result = searcher.search(n).map((item) => {
			const { description, names } = item;
			// eslint-disable-next-line prefer-destructuring
			const name = names[0];
			return {
				...item,
				name: 'emoji',
				title: name,
				description,
				attrs: { markup: name, 'data-name': name },
			};
		});

		return result.slice(0, 10);
	}, [editor.blockMenuSearch]);

	const renderMenuItem = useCallback(
		(item: MenuItem, _index: number, options: Record<string, unknown>) => {
			const emojiItem = item as EmojiMenuItem;

			return (
				<CommandMenuItem
					key={_index}
					// eslint-disable-next-line react/no-unstable-nested-components, react/jsx-no-useless-fragment
					icon={() => <>{emojiItem.emoji}</>}
					title={emojiItem.description}
					{...options}
				>
					{item.title}
				</CommandMenuItem>
			);
		},
		[]
	);

	return (
		<CommandMenu
			editor={editor}
			search={editor.blockMenuSearch ?? ''}
			id="emoji-menu-container"
			trigger=":"
			renderMenuItem={renderMenuItem}
			items={items}
			toolbar={Toolbar.Emoji}
		/>
	);
}
